import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "planning-header" }
const _hoisted_2 = { class: "header-left" }
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = { class: "header-controls" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { value: "two_weeks" }
const _hoisted_7 = { value: "month" }
const _hoisted_8 = { class: "week-range" }
const _hoisted_9 = {
  key: 0,
  class: "filter-badge"
}

import { useI18n } from "vue-i18n";
import enUK from "@/locales/en-UK.json";

type MessageSchema = typeof enUK;


export default /*@__PURE__*/_defineComponent({
  __name: 'PlanningToolbar',
  props: {
    weekRangeLabel: {},
    hasActiveFilters: { type: Boolean },
    activeFilterCount: {},
    viewMode: {}
  },
  emits: ["go-to-today", "previous-period", "next-period", "toggle-filters", "update:view-mode"],
  setup(__props: any) {

const { t } = useI18n<[MessageSchema], "en-UK">({
  useScope: "global",
});





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(t)("titles.myPlanning")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "left-actions"),
      _createElementVNode("select", {
        class: "control-btn view-mode-select",
        value: __props.viewMode,
        onChange: _cache[0] || (_cache[0] = ($event: any) => (
          _ctx.$emit(
            'update:view-mode',
            ($event.target as HTMLSelectElement).value as 'two_weeks' | 'month',
          )
        ))
      }, [
        _createElementVNode("option", _hoisted_6, _toDisplayString(_unref(t)("planning.weekly")), 1),
        _createElementVNode("option", _hoisted_7, _toDisplayString(_unref(t)("planning.monthly")), 1)
      ], 40, _hoisted_5),
      _createElementVNode("button", {
        class: "control-btn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('go-to-today')))
      }, _toDisplayString(_unref(t)("planning.today")), 1),
      _createElementVNode("button", {
        class: "control-btn icon-btn",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('previous-period')))
      }, [...(_cache[5] || (_cache[5] = [
        _createElementVNode("span", { class: "arrow" }, "<", -1)
      ]))]),
      _createElementVNode("span", _hoisted_8, _toDisplayString(__props.weekRangeLabel), 1),
      _createElementVNode("button", {
        class: "control-btn icon-btn",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('next-period')))
      }, [...(_cache[6] || (_cache[6] = [
        _createElementVNode("span", { class: "arrow" }, ">", -1)
      ]))]),
      _createElementVNode("button", {
        class: _normalizeClass(["control-btn filter-btn", { 'filter-btn--active': __props.hasActiveFilters }]),
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('toggle-filters')))
      }, [
        _createTextVNode(_toDisplayString(_unref(t)("planning.filter")) + " ", 1),
        (__props.activeFilterCount > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(__props.activeFilterCount), 1))
          : _createCommentVNode("", true)
      ], 2),
      _renderSlot(_ctx.$slots, "external-actions")
    ])
  ]))
}
}

})